import { Identifiable } from '@custis/common';
import { TTableColumn } from '../../../models';
import React, { useCallback, useMemo } from 'react';
import { FormInstance } from 'antd';
import { uniq } from 'lodash';
import { RowValidationPopoverData } from './models';

export const getInputRulesFromColumnItem = <T extends Identifiable, TFilter, TSorting>(
  item: TTableColumn<T, TFilter, TSorting>,
) => {
  return [
    ...(item.required ? [{ required: true, message: 'Не заполнены обязательные поля.' }] : []),
    ...(item.formItemProps?.rules || []),
  ];
};

export const useSubmitValidate = <T extends Identifiable, TFilter, TSorting>({
  setPopoverData,
  columns,
  visible = true,
  form,
  handleSave,
  setAllFieldsTouched,
}: {
  setPopoverData: React.Dispatch<React.SetStateAction<RowValidationPopoverData>>;
  columns: TTableColumn<T, TFilter, TSorting>[];
  visible?: boolean;
  form: FormInstance<T>;
  handleSave: (row: T) => void;
  setAllFieldsTouched?: () => void;
}) => {
  const validationFieldNames = useMemo(() => {
    return columns.map((item) => String(item.id));
  }, [columns]);

  const onSubmit = useCallback(() => {
    if (setAllFieldsTouched) {
      setAllFieldsTouched();
    }

    void form
      ?.validateFields(validationFieldNames)
      .then((row) => {
        if (visible) {
          handleSave(row);
        }
      })
      .catch((errorsData: { errorFields: { errors: string[] }[] }) => {
        const errorsText = uniq(errorsData?.errorFields.flatMap((er) => er.errors));
        setPopoverData({ errors: errorsText });
      });
  }, [form, validationFieldNames, visible, handleSave]);
  return { onSubmit };
};
